import { Link } from 'react-router-dom';
import { useState } from 'react';
import './Navigation.css';

function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          <img src="/assets/small_robot_logo.png" alt="Small Robot" className="nav-logo-img" />
        </Link>

        <button className="hamburger-menu" onClick={toggleMenu} aria-label="Toggle menu">
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
        </button>

        <div className={`nav-links ${isMenuOpen ? 'nav-links-open' : ''}`}>
          <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link>
          <Link to="/vendors" className="nav-link" onClick={closeMenu}>Vendors</Link>
          <Link to="/apps" className="nav-link" onClick={closeMenu}>Apps</Link>
          <Link to="/faqs" className="nav-link" onClick={closeMenu}>FAQs</Link>
          <Link to="/privacy" className="nav-link" onClick={closeMenu}>Privacy Policy</Link>
          <Link to="/csae" className="nav-link" onClick={closeMenu}>CSAE Policy</Link>
          <Link to="/tos" className="nav-link" onClick={closeMenu}>Terms</Link>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;